// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  AppLogo: 'assets/logos/CDinesh-Logo-Layers.gif',
  AppTitle: 'C. Dinesh & CO.',
  authServe: 'http://localhost:5000',
  domainid: 'AD17E6A0-5331-4D03-847E-CB24B877AABA',
  Clientid: '49A2AF24-CDAB-4E30-B4C6-E624F050D1FE',
  AppUrl: 'http://localhost:4200',
  GrantType: 'password',
  ClientSecret: '49A2AF24-CDAB-4E30-B4C6-E624F050D1FE',
  Scope: 'profile email api.read roles',
  ApiGateway: 'http://localhost:5001',
  ApiStocket: 'http://localhost:5005',
  ApiAdmin: 'http://localhost:5004',
};

///// Server Config

// export const environment = {
//   production: false,
//   AppLogo: "assets/logos/CDinesh-Logo-Layers.gif",
//   AppTitle: "C. Dinesh & CO. PVT. LTD",
//   authServe: "http://server.cdinesh.co/serverApi",
//   domainid: 'AD17E6A0-5331-4D03-847E-CB24B877AABA',
//   Clientid: "49A2AF24-CDAB-4E30-B4C6-E624F050D1FE",
//   AppUrl: "http://new.cdinesh.co/",
//   GrantType: "password",
//   ClientSecret: "49A2AF24-CDAB-4E30-B4C6-E624F050D1FE",
//   Scope: "profile email api.read roles",
//   ApiGateway: "http://gateway.cdinesh.co",
//   ApiStocket: "http://server.cdinesh.co/socketApi/ws",
//   ApiAdmin: 'http://server.cdinesh.co/adminApi',
// };

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
